import { getToken } from './user-service';
import axios from 'axios';

export const getUserReviewHistory = async ({ uuid, code = "DUB" }) => {

    const token = await getToken();

    let url = '/api/v1/review/reviews/getReviews/?userId=' + uuid + '&limit=100&skip=0&code=' + code;

    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }

            //console.log('response from ', json)
            resolve(json);

        } catch (e) {
            reject(new Error("error getting averagee scores"));
        }
    });
};


// get average scores 
export const getAverages = async (params) => {

    const token = await getToken();

    // http://dev.prmassist.com/api/v1/review/statistics/averages/MC?airline=true

    let url = "/api/v1/review/statistics/averages/" + params.iata

    if (params.airline) url = url + '?airline=true'



    return new Promise(async (resolve, reject) => {

        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });

            let json = await response.json();
            // console.log('json ', json)

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }

            resolve(json);

        } catch (e) {
            reject(new Error("error getting averagee scores"));
        }
    });
};
export const getReviewsAverages = async (params) => {

    const token = await getToken();
    const url = `/api/v1/review/statistics/rating?iata=${params.iata}&startDate=${params.startDate}&endDate=${params.endDate}&airline=${params.airline} `;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }
            resolve(json);
        } catch (e) {
            reject(new Error("error getting averagee scores"));
        }
    });
};

export const getWebsiteMetrics = async () => {
    const url = "/api/v1/review/statistics/website-metrics";

    return new Promise(async (resolve, reject) => {
        try {
            const response = await fetch(url, { method: 'GET', headers: { "firebase-uid": 123456789 } });
            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }
            resolve(json);
        } catch (e) {
            reject(new Error("error getting website metrics"));
        }
    });
};

// get reviews list 
export const getReviewsList = async (params) => {

    const token = await getToken();

    let url = ''
    if (params.allBookings) {
        url = "/api/v1/review/reviews/reviewStats?code=" + params.iata + '&limit=10000&skip=' + params.skip + '&mm_yyyy=' + params.mm_yy + '&airline=' + (params.airline ? 'true' : 'false') + '&startDate=2000-01-01&endDate=2100-01-01' + '&airline=' + (params.airline ? 'true' : 'false') + '&queryType=' + (params.airline ? 'airline' : 'airport') + '&reduce=false&include_docs=true'

    } else {
        url = "/api/v1/review/reviews/reviewStats?code=" + params.iata + '&limit=10000&skip=' + params.skip + '&airline=' + (params.airline ? 'true' : 'false') + '&startDate=' + params.startDate + '&endDate=' + params.endDate + '&airline=' + (params.airline ? 'true' : 'false') + '&queryType=' + (params.airline ? 'airline' : 'airport') + '&reduce=false&include_docs=true'
    }

    return new Promise(async (resolve, reject) => {

        try {
            // do the same request with axios
            let response = await axios.get(url, { headers: { "Firebase-UID": token } })
            let json = await response.data

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }

            let mapped = json.map((e) => e.doc)
            resolve(mapped);

        } catch (e) {
            console.log(e)
            reject(new Error("error getting reviews list"));
        }
    });
};

// get scores for heatmap
export const getOverallReviewScores = async (params) => {

    const token = await getToken();

    let url = "/api/v1/review/reviews/reviewStats?code=" + params.iata + "&startDate=" + params.startDate + "&endDate=" + params.endDate + "&reduce=true"

    return new Promise(async (resolve, reject) => {

        try {

            const response = await fetch(url, { method: 'GET', headers: { "Firebase-UID": token } });

            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }

            resolve(json);



        } catch (e) {
            reject(new Error("error getting reviews list"));
        }
    });
};

export const postBookingReview = async (review) => {
    const url = "/api/v1/review/reviews/";
    return new Promise(async (resolve, reject) => {
        try {

            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(review),
                headers: {
                    "Firebase-UID": 123456789,
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            });


            let json = await response.json();

            if (response.status >= 400 && response.status < 600) {
                throw (new Error("Bad details"))
            }
            resolve(json);

        } catch (e) {
            reject(new Error("error getting reviews list"));
        }
    });
}
